import { render, staticRenderFns } from "./CustomerReviewActionCell.vue?vue&type=template&id=95bfb2e6&"
import script from "./CustomerReviewActionCell.vue?vue&type=script&lang=js&"
export * from "./CustomerReviewActionCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports